import { useQuery } from '@apollo/client/react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { Series } from '~/src/common/lean-back/types';

function getFirstEpisodeInSeries(series: Series) {
  return series.seasons[0]?.episodes[0] ?? null;
}
export function useContinueWatchingEpisode(series: Series) {
  const { data, loading } = useQuery<
    gql.typesClient.Query_CurrentUser_ContinueWatchingSeries,
    gql.typesClient.Query_CurrentUser_ContinueWatchingSeriesVariables
  >(gql.Query_CurrentUser_ContinueWatchingSeries, {
    fetchPolicy: 'cache-and-network',
    variables: { seriesId: series.id },
  });

  if (loading || isNil(data)) {
    return {
      isFirstWatch: true,
      nextEpisode: null,
      percentComplete: 0,
      loading,
    };
  }

  const watchDetails = data.CurrentUser_ContinueWatchingSeries;

  const continueWatchingEpisode = watchDetails?.episode;
  const isFirstWatch = isNil(continueWatchingEpisode);
  if (isFirstWatch) {
    const firstEpisode = getFirstEpisodeInSeries(series);
    return {
      nextEpisode: firstEpisode,
      isFirstWatch: true,
      percentComplete: 0,
      loading,
    };
  }

  const episodeDurationInSec = continueWatchingEpisode.media_duration?.seconds ?? 0;
  const watchingPositionInSec = watchDetails?.position_in_seconds ?? 0;
  const percentComplete =
    episodeDurationInSec === 0 ? 0 : (watchingPositionInSec / episodeDurationInSec) * 100;

  return {
    nextEpisode: continueWatchingEpisode,
    isFirstWatch: false,
    percentComplete,
    loading,
  };
}
